import type { PossibleTransition, TransitionAndRankResponse } from '../types';

export function isFailedTransitionAndRankResponse(
	response: unknown,
): response is TransitionAndRankResponse {
	if (response !== null && typeof response === 'object') {
		return 'issuesWereTransitioned' in response && !response.issuesWereTransitioned;
	}
	return false;
}

export function hasTransitionScreens(response: TransitionAndRankResponse): boolean {
	return (
		response.possibleTransitions.length > 0 &&
		response.possibleTransitions.some((transition) => transition.hasTransitionView)
	);
}

export function hasMultipleTransitions(response: TransitionAndRankResponse): boolean {
	return response.possibleTransitions.length > 1;
}

export function getFirstTransitionScreen(
	response: TransitionAndRankResponse,
): PossibleTransition | undefined {
	return response.possibleTransitions.find((transition) => transition.hasTransitionView);
}

export function getPossibleTransitions(response: TransitionAndRankResponse): PossibleTransition[] {
	return response.possibleTransitions || [];
}

export function getNewCardOrder(
	response: TransitionAndRankResponse | string | null,
): string[] | null {
	return response !== null && typeof response === 'object' && response.newIssuesOrder !== undefined
		? response.newIssuesOrder
		: null;
}
